import { useNavigate } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { useLang } from "@/lib/lang";

export default function Privacy() {
  const navigate = useNavigate();
  const { t } = useLang();

  return (
    <div data-testid="privacy-page" className="bg-alabaster pb-24 pt-40 lg:pt-48">
      <div className="mx-auto max-w-3xl px-6 lg:px-12">
        <Reveal>
          <button
            data-testid="privacy-back-home"
            onClick={() => navigate("/")}
            className="link-gold mb-10 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-navy"
          >
            <ArrowLeft size={14} strokeWidth={1.5} className="text-gold-dark" />
            {t.privacy.back}
          </button>
          <div className="flex items-start gap-4">
            <ShieldCheck size={30} strokeWidth={1.1} className="mt-1 shrink-0 text-gold-dark" />
            <div>
              <Overline>{t.privacy.overline}</Overline>
              <h1 data-testid="privacy-title" className="mt-3 font-serif text-4xl font-medium tracking-tight text-navy sm:text-5xl">
                {t.privacy.title}
              </h1>
              <p className="mt-4 text-sm text-muted-ink">{t.privacy.updated}</p>
            </div>
          </div>
        </Reveal>

        <div className="mt-14 divide-y divide-hairline border-t border-hairline">
          {t.privacy.sections.map((s, i) => (
            <Reveal key={s.title} delay={0.04 * i}>
              <section className="py-8">
                <h2 className="font-serif text-xl font-semibold text-navy sm:text-2xl">{s.title}</h2>
                {s.body.map((p, j) => (
                  <p key={j} className="mt-4 text-sm leading-relaxed text-muted-ink sm:text-base">
                    {p}
                  </p>
                ))}
              </section>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
